import * as React from 'react';
import api from '../../services';

const NewLetter = (props) => {
	
	const onNewLetter = (e) => {
		e.preventDefault();
		var email: any = document.getElementById('email');
		api.newLetter({
			body: {
				email: email.value
			}
		}).then((res) => {
			var form_input: any = document.getElementById("myForm");
			form_input.reset();
			var showMessage: any = document.getElementById('showMessage');
			showMessage.innerHTML = '<div class="alert alert-success alert-dismissible fade show" role="alert">Đăng ký nhận tin thành công.</div>';
			setTimeout(() => {
				showMessage.innerHTML = '';
			}, 3000);
		}).catch((err) => {
			var form_input: any = document.getElementById("myForm");
			form_input.reset();
			var showMessage: any = document.getElementById('showMessage');
			showMessage.innerHTML = '<div class="alert alert-success alert-dismissible fade show" role="alert">Đăng ký nhận tin thành công.</div>';
			setTimeout(() => {
				showMessage.innerHTML = '';
			}, 3000);
		})
	};
	
	return (
		<div className="newsletter-widget mb-4">
			<p className="heading">Đăng ký theo dõi</p>
			<img className="logo" src={require('../../img/logo.png')} width={100}/>
			<p className="description">Nhận những thông tin mới nhất từ Cộng Cà Phê.</p>
			<form onSubmit={onNewLetter} id="myForm">
				<div className="input-group">
					<input required className="form-control newsletter-email" name="email" id="email" size={16} type="email"
					       placeholder="Nhập địa chỉ email"/>
					<span className="input-group-btn">
						<button className="btn btn-default" type="submit" name="subscribe" id="mc-embedded-subscribe"> Đăng Ký </button>
					</span>
				</div>
			</form>
			<div id="showMessage"></div>
		</div>
	);
};

export default NewLetter;



// WEBPACK FOOTER //
// ./src/containers/component/NewLetter.tsx